import { PAGES } from "@dune/types";
import { Button, ResizableLayout, Skeleton } from "@dune/ui";
import { ArrowLeft } from "@untitled-ui/icons-react";
import { useNavigate } from "react-router-dom";

export const PartnershipRequestAnalysisSkeleton = () => {
	const navigate = useNavigate();

	return (
		<ResizableLayout>
			<ResizableLayout.Main className="p-4 md:p-6">
				<div className="w-full h-full flex flex-col">
					<div className="mb-2">
						<Button
							variant="ghost"
							className="text-text-main-blue"
							onClick={() => navigate(PAGES.BROKER_LIST)}
						>
							<ArrowLeft /> Retour
						</Button>
					</div>
					<div className="flex items-center justify-between mb-4">
						<h1 className="text-2xl font-semibold text-foreground">
							Analyse demande de partenariat
						</h1>
					</div>

					<div className="space-y-6">
						{/* État de validation */}
						<Skeleton className="h-32 w-full" />

						{/* Section société */}
						<div className="space-y-4">
							<Skeleton className="h-6 w-48" />
							<div className="flex gap-6">
								<Skeleton className="h-64 flex-1" />
								<Skeleton className="h-64 w-96" />
							</div>
						</div>

						{/* Section utilisateur */}
						<div className="space-y-4">
							<Skeleton className="h-6 w-48" />
							<div className="flex gap-6">
								<Skeleton className="h-96 flex-1" />
								<div className="space-y-4 w-96">
									<Skeleton className="h-48" />
									<Skeleton className="h-48" />
								</div>
							</div>
						</div>

						{/* Sections supplémentaires */}
						<Skeleton className="h-48 w-full" />
						<Skeleton className="h-48 w-full" />
						<Skeleton className="h-64 w-full" />
					</div>
				</div>
			</ResizableLayout.Main>
		</ResizableLayout>
	);
};
